let timeout;

export function cartUpdateQuantity() {
    const input = document.querySelector('.cart-item__quantity .quantity__input');
    const trigger = document.querySelector('.cart-table__actions .button');

    if (input !== null && trigger !== null) {
        document.addEventListener('quantityChange', (event) => {

            if (timeout !== undefined) {
                clearTimeout(timeout);
            }

            timeout = setTimeout(function () {
                trigger.click();
            }, 1000); // 1 second delay, half a second (500) seems comfortable too
        });
    }
}